const unique = <T>(array: T[], attribute: string): T[] => {
  const seen = new Set<string>();
  return array.filter((obj) => {
    const value = (obj as Record<string, unknown>)[attribute] as string;
    if (seen.has(value)) {
      return false;
    }
    seen.add(value!);
    return true;
  });
};

export const ArrayService = {
  unique,
};
